var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.55433 10.0479L6.50016 10.1021L6.44058 10.0479C3.86766 7.71333 2.16683 6.16958 2.16683 4.60417C2.16683 3.52083 2.97933 2.70833 4.06266 2.70833C4.89683 2.70833 5.70933 3.25 5.99641 3.98667H7.00391C7.291 3.25 8.1035 2.70833 8.93766 2.70833C10.021 2.70833 10.8335 3.52083 10.8335 4.60417C10.8335 6.16958 9.13266 7.71333 6.55433 10.0479ZM8.93766 1.625C7.99516 1.625 7.09058 2.06375 6.50016 2.75167C5.90975 2.06375 5.00516 1.625 4.06266 1.625C2.39433 1.625 1.0835 2.93042 1.0835 4.60417C1.0835 6.64625 2.92516 8.32 5.71475 10.8496L6.50016 11.5646L7.28558 10.8496C10.0752 8.32 11.9168 6.64625 11.9168 4.60417C11.9168 2.93042 10.606 1.625 8.93766 1.625Z",
    fill: "#43796E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.b59cea9b6ffddfbc541a4d5c6a19fd5c.svg";
export { ForwardRef as ReactComponent };